import React, { useCallback, useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import cn from '../../../../lib/bem';
import {
  addRegistroDatos,
  postCaptcha,
} from '../../../../redux/reducers/simuladorFVGSlice';
import ico_cancel_circle from './../../../../assets/svg/ico_cancel_circle.svg';
import InputTextComponent from '../../../../components/inputText/inputText_component';
import InputCheckComponent from '../../../../components/inputCheck/inputCheck_component';
import ButtonComponent from '../../../../components/button/button_component';
import img_persona_laptop from './../../../../assets/svg/img_persona_laptop.svg';
import { validarCorreo } from '../../../../lib/utils';
import { patchConfirmarInformacion } from '../../../../redux/reducers/simuladorFVGSlice';
import { useGoogleReCaptcha } from 'react-google-recaptcha-v3';

import './modalConfirmarDatos_Component.scss';
import EloquaFormComponent from '../eloquaForm/eloquaForm_Component';
import { gtmOnclickConfirmarDatosContinuar, gtmOnclickConfirmarDatosOpen } from '../../../../gtm/simulacion';

const ModalConfirmarDatosComponent = (props) => {
  const classes = cn('modalConfirmarDatosComponent');
  const dispatch = useDispatch();

  const simuladorFVG = useSelector((state) => state.rootReducers.simuladorFVG);

  const [celular, guardarCelular] = useState(simuladorFVG.celular);
  const [msgCelular, guardarMsgCelular] = useState('');
  const [correoEle, guardarCorreoEle] = useState(simuladorFVG.correoEle);
  const [msgCorreoEle, guardarMsgCorreoEle] = useState('');
  const [terminosConfirma, guardarTerminosConfirma] = useState(
    simuladorFVG.terminos
  );
  const [msgTerminos, guardarMsgTerminos] = useState('');

  const { executeRecaptcha } = useGoogleReCaptcha();

  const onClickGuardarDatos = useCallback(async () => {
    if (celular.trim() === '') {
      guardarMsgCelular('El campo es obligatorio');
      return false;
    }

    if (celular.length < 9) {
      guardarMsgCelular('Completar el campo');
      return false;
    }

    if (celular.length > 11) {
      guardarMsgCelular('Celular no valido');
      return false;
    }

    if (correoEle.trim() === '') {
      guardarMsgCorreoEle('El campo es obligatorio');
      return false;
    }

    if (!validarCorreo(correoEle.trim())) {
      guardarMsgCorreoEle('El campo debe ser un correo electrónico válido');
      return false;
    }
    dispatch(
      addRegistroDatos({
        nombre: simuladorFVG.nombre,
        apePaterno: simuladorFVG.apePaterno,
        apeMaterno: simuladorFVG.apeMaterno,
        fecNacimiento: simuladorFVG.fecNacimiento,
        genero: simuladorFVG.genero,
        celular: celular,
        correoEle: correoEle,
        terminos: simuladorFVG.terminos,
        terminosConfir: terminosConfirma,
      })
    );

    const token = await executeRecaptcha('ecowebapp');

    if (process.env.REACT_APP_ACTIVE_VALIDATION_RECAPTCHA === 'true') {
      dispatch(postCaptcha(token)).then((resp) => {
        if (resp.payload.datos.esValido) {
          dispatch(
            patchConfirmarInformacion({
              idSimulacion: simuladorFVG.idSimulacion,
              celular: celular,
              correoEle: correoEle,
              terminos: terminosConfirma,
            })
          );
        }
      });
    } else {
      dispatch(
        patchConfirmarInformacion({
          idSimulacion: simuladorFVG.idSimulacion,
          celular: celular,
          correoEle: correoEle,
          terminos: terminosConfirma,
        })
      );
    }

    props.onClose();
  }, [
    celular,
    correoEle,
    dispatch,
    executeRecaptcha,
    props,
    simuladorFVG.apeMaterno,
    simuladorFVG.apePaterno,
    simuladorFVG.fecNacimiento,
    simuladorFVG.genero,
    simuladorFVG.idSimulacion,
    simuladorFVG.nombre,
    simuladorFVG.terminos,
    terminosConfirma
  ])

  const disableButtonActualiz =
    celular !== '' && correoEle !== '' && terminosConfirma ? false : true;

  useEffect(() => {
    const pageTitle = localStorage.getItem("gtmPageTitle");
    gtmOnclickConfirmarDatosOpen(pageTitle);
  }, []);

  const handleClickContinuar = useCallback(() => {
    if (!simuladorFVG.nombreProspecto) {
      onClickGuardarDatos();
    }

    if (terminosConfirma) {
      const pageTitle = localStorage.getItem('gtmPageTitle');
      gtmOnclickConfirmarDatosContinuar(pageTitle)
    }
  }, [onClickGuardarDatos, simuladorFVG.nombreProspecto, terminosConfirma]);

  return (
    <div className={classes()}>
      <div className={classes('container')}>
        <div className={classes('content')}>
          <div className={classes('contentImg')}>
            <img src={img_persona_laptop} alt="img_persona_laptop" />
          </div>
          <div className={classes('contentForm')}>
            <img
              className={classes('contentClose')}
              src={ico_cancel_circle}
              alt={'ico_cancel_circle'}
              onClick={() => props.onClose()}
            />
            <p className={classes('contentTitle')}>
              <b>Confirma tus datos</b>
            </p>
            <div>
              {simuladorFVG.nombreProspecto ? (
                <EloquaFormComponent
                  guardarCelular={guardarCelular}
                  celular={celular}
                  msgCelular={msgCelular}
                  guardarMsgCelular={guardarMsgCelular}
                  guardarCorreoEle={guardarCorreoEle}
                  correoEle={correoEle}
                  msgCorreoEle={msgCorreoEle}
                  guardarMsgCorreoEle={guardarMsgCorreoEle}
                  terminosConfirma={terminosConfirma}
                  guardarMsgTerminos={guardarMsgTerminos}
                  onClose={props.onClose}
                  mostrarSuccessMessage={props.mostrarSuccessMessage}
                />
              ) : (
                <>
                  <InputTextComponent
                    inputText={'Celular'}
                    inputValue={celular}
                    inputAction={guardarCelular}
                    inputWidth={100}
                    type={'number'}
                    inputMsg={msgCelular}
                    inputActionMsg={guardarMsgCelular}
                    styleText={''}
                  />
                  <InputTextComponent
                    inputText={'Correo'}
                    inputValue={correoEle}
                    inputAction={guardarCorreoEle}
                    inputWidth={100}
                    type={''}
                    inputMsg={msgCorreoEle}
                    inputActionMsg={guardarMsgCorreoEle}
                    styleText={''}
                  />
                </>
              )}
              <InputCheckComponent
                inputValue={terminosConfirma}
                inputAction={guardarTerminosConfirma}
                inputText={[
                  <a
                    key={'linkTerminos'}
                    className={classes('inputCheckLink')}
                    target="_blank"
                    href="https://www.pacifico.com.pe/terminos-condiciones-ecommerce"
                    rel="noreferrer"
                  >
                    {' '}
                    He leído y acepto las condiciones establecidas en la
                    cláusula de{' '}
                    <span className={classes('inputCheckSpan')}>
                      protección de datos personales.
                    </span>
                  </a>,
                ]}
              />
              {msgTerminos && (
                <label className={classes('inputTextoLabelError')}>
                  {msgTerminos}
                </label>
              )}
              <div className={classes('contentButton')}>
                <ButtonComponent
                  form="form70"
                  type={simuladorFVG.nombreProspecto ? 'submit' : 'button'}
                  label={'btnContinuarRegistro'}
                  tipo={'button-red'}
                  disabled={disableButtonActualiz}
                  action={handleClickContinuar}
                  nombre={'Continuar'}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ModalConfirmarDatosComponent;
